import { Box, VStack, Heading, Spacer, Container } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

const pathImageMap = {
  "/": process.env.PUBLIC_URL + "/images/home.jpg",
  "/about/mission": process.env.PUBLIC_URL + "/images/mission.jpg",
  "/about/news": process.env.PUBLIC_URL + "/images/news.jpg",
  "/about/career": process.env.PUBLIC_URL + "/images/career.jpg",
  "/about/visit-us": process.env.PUBLIC_URL + "/images/visit-us.jpg",
  "/about/publications": process.env.PUBLIC_URL + "/images/talos.jpeg",
  "/people/committee": process.env.PUBLIC_URL + "/images/committee.jpg",
  "/people/staff": process.env.PUBLIC_URL + "/images/staff.jpg",
  "/resources/pricing": process.env.PUBLIC_URL + "/images/pricing.jpeg",
  "/capabilities/cni-services": process.env.PUBLIC_URL + "/images/talos.jpeg",
  "/resources": process.env.PUBLIC_URL + "/images/instrumentation.jpg",
  "/resources/microscope": process.env.PUBLIC_URL + "/images/microscope.jpg",
  "/resources/sample-preparation":
    process.env.PUBLIC_URL + "/images/microscope.jpg",
  "/resources/x-ray": process.env.PUBLIC_URL + "/images/microscope.jpg",
  "/resources/availability":
    process.env.PUBLIC_URL + "/images/Instrument_Availability.png",
  "/resources/instrumentation":
    process.env.PUBLIC_URL + "/images/instrumentation.jpg",
  "/capabilities/sample-submittal":
    process.env.PUBLIC_URL + "/images/sample-submittal.png",
  "/new-user": process.env.PUBLIC_URL + "/images/sample-submittal.png",
  "/about/policy": process.env.PUBLIC_URL + "/images/policy.jpg",
  "/about/equipment-donation":
    process.env.PUBLIC_URL + "/images/equipment-donation.jpg",
  "/login": process.env.PUBLIC_URL + "/images/login.jpeg",
  "/new-login": process.env.PUBLIC_URL + "/images/login.jpeg",
};

const Header = ({ backgroundImage }) => {
  const { pathname } = useLocation();
  let finalPathname = pathname;
  if (pathname.length > 1 && pathname.endsWith("/")) {
    finalPathname = pathname.substring(0, pathname.length - 1);
  }
  const bgImage = backgroundImage || pathImageMap[finalPathname];
  // return (<></>);
  return (
    <Box
      backgroundImage={bgImage}
      backgroundSize="cover"
      backgroundPosition="center"
      mt={0}
      pt={0}
      w="100%"
    >
      <VStack
        bgGradient={"linear(to-r, blackAlpha.600, transparent)"}
        align="center"
        pb={8}
      >
        <Box h={["30px", "30px", "60px"]} />

        <Container maxW="container.lg">
          <Heading as="h1" size="4xl" color="white">
            CNI
          </Heading>
        </Container>
        <Spacer />

        <Box h={["120px", "120px", "190px"]} />

        <Container maxW="container.lg">
          <Heading
            as="h2"
            size="xl"
            fontSize={["2xl", "2xl", "4xl", "4xl"]}
            color="white"
          >
            Core Center of Excellence in Nano Imaging
          </Heading>
        </Container>
      </VStack>
    </Box>
  );
};

export default Header;
